import React, { useState } from 'react';

const Image = ({ src, alt = '', fallback = null, ...props }) => {
  const [error, setError] = useState(false);
  const [currentSrc, setCurrentSrc] = useState(null);

  const getImageUrl = (path) => {
    // We go direct to cdn now, instead of server
    if (path?.startsWith('/public/')) {
      return `${process.env.REACT_APP_CDN_URL}${path}`;
    }
    return path;
  };

  // Reset error state when src changes
  React.useEffect(() => {
    setError(false);
    setCurrentSrc(getImageUrl(src));
  }, [src]);

  const handleError = (e) => {
    console.error(`Failed to load image: ${currentSrc}`, e);
    setError(true);

    // If there's a fallback, try to use it
    if (fallback && currentSrc !== fallback) {
      setCurrentSrc(fallback);
      setError(false);
    }
  };

  // If error and no fallback worked, don't render anything
  if (error) {
    return null;
  }

  return (
    <img
      src={currentSrc}
      alt={alt}
      onError={handleError}
      {...props}
    />
  );
};

export default Image;
